﻿/*
 * Globalize Culture id-ID
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("id-ID", "default", {
    name: "id-ID",
    englishName: "Indonesian (Indonesia)",
    nativeName: "Bahasa Indonesia (Indonesia)",
    language: "id",
    numberFormat: {
      ",": ".",
      ".": ",",
      percent: {
        ",": ".",
        ".": ","
      },
      currency: {
        decimals: 0,
        ",": ".",
        ".": ",",
        symbol: "Rp"
      }
    },
    calendars: {
      standard: {
        firstDay: 1,
        days: {
          names: [
            "Minggu",
            "Senin",
            "Selasa",
            "Rabu",
            "Kamis",
            "Jumat",
            "Sabtu"
          ],
          namesAbbr: [
            "Minggu",
            "Sen",
            "Sel",
            "Rabu",
            "Kamis",
            "Jumat",
            "Sabtu"
          ],
          namesShort: ["M", "S", "S", "R", "K", "J", "S"]
        },
        months: {
          names: [
            "Januari",
            "Februari",
            "Maret",
            "April",
            "Mei",
            "Juni",
            "Juli",
            "Agustus",
            "September",
            "Oktober",
            "Nopember",
            "Desember",
            ""
          ],
          namesAbbr: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Mei",
            "Jun",
            "Jul",
            "Agust",
            "Sep",
            "Okt",
            "Nop",
            "Des",
            ""
          ]
        },
        AM: null,
        PM: null,
        patterns: {
          d: "dd/MM/yyyy",
          D: "dd MMMM yyyy",
          t: "H:mm",
          T: "H:mm:ss",
          f: "dd MMMM yyyy H:mm",
          F: "dd MMMM yyyy H:mm:ss",
          M: "dd MMMM",
          Y: "MMMM yyyy"
        }
      }
    },
    messages: {
      AdditionalHelp: "Bantuan Tambahan",
      AddNewTab: "Tambahkan Tab Baru",
      Alerts: "Peringatan",
      ApplyFilter: "Terapkan Filter",
      Approve: "Setuju",
      Attachments: "Lampiran",
      Back: "Kembali",
      Basic: "Dasar",
      Between: "Antara",
      Book: "Buku",
      Cancel: "Batalkan",
      Checked: "Diperiksa",
      ClearFilter: "Bersihkan Filter",
      Close: "Tutup",
      CloseCancelChanges: "Tutup dan Batalkan Perubahan",
      CloseSaveChanges: "Tutup dan Simpan Perubahan",
      CloseTab: "Tutup Tab",
      ColumnPersonalization: "Personalisasi Kolom",
      Comments: "Komentar",
      Confirmation: "Konfirmasi",
      Contains: "Berisi",
      CreateTab: "Buat Tab baru",
      Cut: "Potong",
      Delete: "Hapus",
      DiscardUndo: "Batalkan/Kembalikan",
      DisplayDropDownList: "Tampilkan daftar Dropdown",
      Displaying: "Sedang menampilkan: ",
      DocWord: "Dokumen",
      DoesNotContain: "Tidak Berisi",
      DoesNotEndWith: "Tidak Berakhir Dengan",
      DoesNotEqual: "Tidak Sama Dengan",
      DoesNotStartWith: "Tidak Mulai Dengan",
      Download: "Unduh",
      Duplicate: "Duplikat",
      Edit: "Edit",
      EitherSelectedorNotSelected: "Salah Satu Dipilih atau Tidak Dipilih",
      Email: "Email",
      EndsWith: "Berakhir Dengan",
      EqualsStr: "Sama dengan",
      ExpandCollapse: "Luaskan/Ciutkan",
      ExportFailed: "Ekspor Gagal",
      ExportToExcel: "Ekspor ke Excel",
      FileInUse: "File yang diminta sedang Digunakan",
      FileInUseDetail:
        "Tutup file pada aplikasi yang menggunakan file tersebut atau tentukan nama file yang berbeda.",
      Filter: "Filter",
      FilterMenu: "Menu Filter",
      FilterOptions: "Opsi Filter",
      FilterWithinResults: "Filter Pada Hasil",
      First: "Pertama",
      FirstView: "Tampilan Pertama",
      Folder: "Folder",
      ForgotPassword: "Lupa Kata Sandi?",
      Forward: "Teruskan",
      GetMoreRows: "Dapatkan Baris Lagi",
      GreaterThan: "Lebih Besar Dari",
      GreaterThanOrEquals: "Lebih Besar Dari atau Sama Dengan",
      GridSettings: "Pengaturan Grid",
      GroupSelection: "Pemilihan Grup",
      Help: "Bantuan",
      HideColumn: "Sembunyikan Kolom",
      IsEmpty: "Kosong",
      IsNotEmpty: "Tidak Kosong",
      Last: "Terakhir",
      LastView: "Tampilan Terakhir",
      LaunchActivate: "Luncurkan/Aktifkan",
      LessThan: "Kurang Dari",
      LessThanOrEquals: "Kurang Dari atau Sama Dengan",
      Links: "Tautan",
      ListTabs: "Daftar semua Tab",
      LoadingItem: "Memuat item ",
      Maintenance: "Pemeliharaan",
      Menu: "Menu",
      New: "Baru",
      Next: "Berikutnya",
      NextView: "Tampilan Selanjutnya",
      No: "Tidak",
      NotChecked: "Tidak Diperiksa",
      Notes: "Catatan",
      NotSelected: "Tidak Dipilih",
      Of: " dari ",
      Ok: "OKE",
      Open: "Buka",
      Password: "Kata Sandi",
      Paste: "Tempel",
      Phone: "Telepon",
      PleaseWait: "Mohon Tunggu",
      Previous: "Sebelumnya",
      PreviousView: "Tampilan Sebelumnya",
      Print: "Cetak",
      Queries: "Kueri",
      Redo: "Lakukan lagi",
      Refresh: "Segarkan",
      Reject: "Tolak",
      RememberMe: "Ingat saya pada komputer ini",
      Reports: "Laporan",
      Reset: "Reset",
      Review: "Kaji Ulang",
      RunFilter: "Jalankan Filter",
      RunJob: "Jalankan Pekerjaan",
      Save: "Simpan",
      SaveBeforeClosing: "Simpan Sebelum Menutup",
      SavedFilters: "Filter Tersimpan",
      SaveSubmit: "Simpan/Serahkan",
      ScreenDesign: "Desain Layar",
      Search: "Cari",
      SelectContents: "Pilih Konten",
      SelectDate: "Pilih Tanggal",
      SelectDeselect: "Pilih / Batal Pilih Semua",
      Selected: "Dipilih: ",
      ServerName: "Nama Server",
      Settings: "Pengaturan",
      ShowFilterRow: "Tampilkan Baris Filter",
      SignIn: "Masuk",
      SortAscending: "Sortir Naik",
      SortDescending: "Sortir Turun",
      Spreadsheet: "Lembar matriks",
      StartsWith: "Mulai Dengan",
      StatusIndicator: "Indikator Status",
      Tasks: "Tugas",
      Today: "Hari Ini",
      Translate: "Terjemahkan",
      UserID: "ID Pengguna",
      Utilities: "Utilitas",
      Yes: "Ya",
      Page: "Halaman",
      Rows: "Baris",
      ShowingAll: "Menampilkan Semua",
      SessionNavigation: "Navigasi Sesi",
      ListAllMenuItems: "Daftar Semua Item Menu",
      NoRecordsFound: "Rekaman Tidak Ditemukan",
      SearchTree: "Pohon Pencarian",
      Clear: "Bersihkan",
      DrillDown: "Drill Turun",
      Required: "Bidang ini harus diisi",
      Available: "Tersedia:",
      Add: "Tambahkan",
      MoveDown: "Geser ke Bawah",
      MoveUp: "Geser ke Atas",
      Remove: "Buang",
      LastYear: "Tahun Lalu",
      NextMonth: "Bulan Depan",
      NextWeek: "Minggu Depan",
      NextYear: "Tahun Depan",
      OneMonthAgo: "Satu Bulan Lalu",
      OneWeekAgo: "Satu Minggu Lalu",
      SixMonthsAgo: "Enam Bulan Lalu",
      Time: "Waktu",
      CannotBeSelected: "Baris ini tidak dapat dipilih.",
      ResetToDefault: "Reset ke Tata Letak Awal",
      CloseOtherTabs: "Tutup Tab Lain",
      EmailValidation: "Masukkan alamat email yang valid",
      UrlValidation: "Masukkan URL yang valid",
      EndofResults: "Akhir Hasil",
      More: "Lebih banyak lagi...",
      RecordsPerPage: "Rekaman Per Halaman",
      Maximize: "Maksimalkan",
      Minimize: "Memperkecil"
    }
  });
})(this);
